var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ConfigureComponentBase } from '../../../shared/configure-component-base';
var LeaveWorkshopWarningModalComponent = /** @class */ (function (_super) {
    __extends(LeaveWorkshopWarningModalComponent, _super);
    function LeaveWorkshopWarningModalComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.onSave = new EventEmitter();
        _this.onUnSave = new EventEmitter();
        return _this;
    }
    LeaveWorkshopWarningModalComponent.prototype.save = function () {
        this.onSave.emit();
        this.cancel();
    };
    LeaveWorkshopWarningModalComponent.prototype.unSave = function () {
        this.onUnSave.emit();
        this.cancel();
    };
    LeaveWorkshopWarningModalComponent.prototype.cancel = function () {
        this.modal.hide();
    };
    LeaveWorkshopWarningModalComponent.prototype.show = function () {
        this.modal.show();
    };
    __decorate([
        ViewChild('leaveWorkshopWarningModal', { static: false })
    ], LeaveWorkshopWarningModalComponent.prototype, "modal", void 0);
    __decorate([
        Input()
    ], LeaveWorkshopWarningModalComponent.prototype, "name", void 0);
    __decorate([
        Input()
    ], LeaveWorkshopWarningModalComponent.prototype, "customWaringName", void 0);
    __decorate([
        Output()
    ], LeaveWorkshopWarningModalComponent.prototype, "onSave", void 0);
    __decorate([
        Output()
    ], LeaveWorkshopWarningModalComponent.prototype, "onUnSave", void 0);
    LeaveWorkshopWarningModalComponent = __decorate([
        Component({
            selector: 'app-leave-workshop-warning',
            template: "<div bsModal #leaveWorkshopWarningModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\"> <div class=\"modal-content\"> <div class=\"fe-modal-container\"> <div class=\"fe-modal-header modal-border-bottom\"> <h4 class=\"fe-modal-header-title\"> {{lc('Note')}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"cancel()\">×</div> </div> <div class=\"fe-modal-middle margin-top-10\"> <h5 *ngIf=\"name\">{{lc('LeaveWorkshopWarning',name)}}</h5> <h5 *ngIf=\"!name\">{{customWaringName}}</h5> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"save()\"> {{lc(\"Save\")}} </button> <button class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"unSave()\">{{lc('UnSave')}}</button> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"cancel()\"> {{l(\"Cancel\")}} </button> </div> </div> </div> </div> </div> </div> "
        })
    ], LeaveWorkshopWarningModalComponent);
    return LeaveWorkshopWarningModalComponent;
}(ConfigureComponentBase));
export { LeaveWorkshopWarningModalComponent };
